<template>
  <v-row no-gutters>
    <v-col cols="8" v-if="searchRequired"> </v-col>
    <v-col cols="4" v-if="searchRequired" class="mt-0 mb-4 d-flex">
      <v-text-field
        label="Search Items Here.."
        hide-details="auto"
        prepend-inner-icon="mdi-magnify"
        v-model="filter.search"
        outlined
        dense
        clearable
        @keydown.enter="searchOrderItem()"
        @click:clear="searchOrderItem(true)"
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <AgGridVue
        @grid-ready="gridReady"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="itemList"
        style="width: 100%; height: calc(100vh - 550px)"
        class="ag-theme-balham"
      >
      </AgGridVue>
    </v-col>
    <v-col cols="6" class="d-flex align-center justify-start">
      <PaginationCount :total="totalItems" />
    </v-col>
    <v-col cols="6" class="pt-3 d-flex justify-end">
      <Pagination
        :pageNo="pageNo"
        :totalItems="totalItems"
        :pageSize="itemsPerPage"
        @itemsPerPageChange="itemsPerPageChanged"
        @prevPage="prevPage"
        @nextPage="nextPage"
      />
    </v-col>
  </v-row>
</template>

<script>
import { bus } from "@/main";
import { AgGridVue } from "ag-grid-vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import PaginationCount from "@/components/BaseComponents/PaginationCount.vue";

export default {
  props: {
    value: Boolean,
    orderId: {
      required: true,
    },
    status: {
      required: true,
    },
    searchRequired: {
      required: false,
    },
  },

  components: {
    AgGridVue,
    BaseDialog,
    Pagination,
    PaginationCount,
  },
  watch: {
    orderId(val) {
      if (val) {
        this.getItemList();
      }
    },
  },
  data() {
    return {
      itemsPerPage: 10,
      filter: {},
      itemList: [],
      defaultColDef: {
        lockPosition: true,
        flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },
      gridApi: null,
      columnApi: null,
      totalItems: 0,
      pageNo: 1,
      gridOptions: {
        onGridSizeChanged: () => {
          this.autoSizeAll();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },

    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },

    orderItemListDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    columnDefs() {
      let headers = [
        {
          headerName: "item number",
          field: "item_no",
          resizable: true,
          minWidth: 150,
          pinned: "left",
        },
        {
          headerName: "Item Description",
          field: "description",
          resizable: true,
        },
        // {
        //   headerName: "status",
        //   field: "line_status",
        //   resizable: true,
        // },
        {
          headerName: "Storage Type",
          field: "storage_type",
          resizable: true,
        },
        {
          headerName: "CBM",
          field: "volume",
          resizable: true,
        },
        {
          headerName: "weight",
          field: "weight",
          resizable: true,
        },
        {
          headerName: "original quantity",
          field: "original_quantity",
          resizable: true,
          minWidth: 150,
        },
        {
          headerName: "picked up quantity",
          field: "pickedup_quantity",
          resizable: true,
          minWidth: 150,
        },
      ];
      if (this.status == "partially_delivered" || this.status == "delivered") {
        headers.push({
          headerName: "Total delivered Item ",
          field: "delivered_quantity",
          resizable: true,
          minWidth: 150,
        });
      }
      return headers;
    },
  },
  methods: {
    autoSizeAll() {
      let allColumnIds = [];
      this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },
    nextPage() {
      this.pageNo++;
      this.getItemList();
    },
    prevPage() {
      this.pageNo--;
      this.getItemList();
    },
    itemsPerPageChanged(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getItemList();
    },
    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    closeDialog() {
      this.orderItemListDialog = false;
    },
    searchOrderItem(searchClear = false) {
      if (searchClear) {
        delete this.filter.search;
      }
      this.getItemList();
    },

    getItemList(params = {}) {
      params = {
        order: this.orderId,
        ...this.filter,
        limit: this.itemsPerPage,
        offset: this.offset,
      };
      bus.$emit("showLoader", true);
      this.$api.order
        .getOrderItemList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.itemList = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    this.getItemList();
  },
};
</script>
